import type { BundleDetails } from "@memorang/types";

const fetchBundleList = async (
	_tenantId: string,
	_isWeb: boolean,
): Promise<BundleDetails[]> => {
	return [];
};

export default fetchBundleList;
